import {FC} from 'react'
import {useSelector} from 'react-redux'
import {getAllUserDetails} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {InboxWrapper as InboxV2} from '../inbox-v2/Inbox'
import {InboxWrapper as InboxV3} from '../inbox-v3/Inbox'

/**
 * Conditional Inbox Wrapper
 * Renders InboxV3 when newInbox is enabled in user's globalSetting,
 * otherwise renders InboxV2 (legacy inbox)
 */
const InboxConditionalWrapper: FC = () => {
  const userData: any = useSelector(getAllUserDetails)
  const isNewInboxEnabled = userData?.globalSetting?.includes('newInbox')

  if (isNewInboxEnabled) {
    return <InboxV3 />
  }

  return <InboxV2 />
}

export {InboxConditionalWrapper}
